// extracted by mini-css-extract-plugin
export var brochureContentWrapper = "RequestBrochureGroupPage-module--brochure-content-wrapper--6205c";
export var brochureGroupResults = "RequestBrochureGroupPage-module--brochure-group-results--773c0";